import { useEffect, useRef } from "react";

/**
 * Embeds the TeamUp booking calendar widget.
 * Injects the TeamUp loader and the init call into a ref-controlled container so
 * teamup.js renders the calendar inside this component (it uses document.currentScript
 * to locate its render target).
 */
export default function TeamUpCalendar({
  providerId = 13190668,
  view = "schedule.month",
}) {
  const containerRef = useRef(null);
  const initedRef = useRef(false);

  useEffect(() => {
    if (initedRef.current || !containerRef.current) return;
    initedRef.current = true;

    const container = containerRef.current;

    const loader = document.createElement("script");
    loader.src = "https://teamupstatic.com/teamup.js";
    loader.type = "text/javascript";
    loader.async = false;

    loader.onload = () => {
      if (!container.isConnected) return;
      const init = document.createElement("script");
      init.type = "text/javascript";
      init.text = `teamup.calendar({
        provider_id: ${providerId},
        type: "main",
        width: "100%",
        specific_pages: [],
        view: "${view}",
        venue_ids: "~all",
        free_trial_membership: "",
        disable_venue_selector: false,
        version: 3
      });`;
      container.appendChild(init);
    };

    container.appendChild(loader);
  }, [providerId, view]);

  return (
    <div
      ref={containerRef}
      data-testid="teamup-calendar"
      className="min-h-[600px] bg-white rounded-2xl border border-kore-gold/15 p-4 md:p-6 shadow-soft"
    />
  );
}
